import { render, staticRenderFns } from "./business_edit.vue?vue&type=template&id=6f5061e9&scoped=true&"
import script from "./business_edit.vue?vue&type=script&lang=js&"
export * from "./business_edit.vue?vue&type=script&lang=js&"
import style0 from "./business_edit.vue?vue&type=style&index=0&id=6f5061e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5061e9",
  null
  
)

export default component.exports